module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_7016.cb9285dc.png";